export const TELCO_CHANNELS = ['data_spark', 'au_telco'];

// Tab names used in audience explorer
export const EXPLORER_TAB_NAMES = {
  wiki: 'wiki',
  tv: 'tv',
  categories: 'categories',
  purchaseAffinities: 'purchase_affinities',
};

// Tab configuration for audience explorer
export const EXPLORER_TAB_VALUES = {
  DEMOGRAPHICS: 'demographics',
  DOMAIN: 'domain',
  KEYWORDS: 'keywords',
  WEB: 'web',
  WIKI: 'wiki',
  TV: 'tv',
  CATEGORIES: 'categories',
  PURCHASE_AFFINITIES: 'purchase_affinities',
  LINKEDIN_INTERESTS: 'linkedin_interests',
};

// Tab labels
export const EXPLORER_TAB_LABELS = {
  DEMOGRAPHICS: 'Demographics',
  WEBSITES: 'Websites',
  KEYWORDS: 'Keywords',
  CONSUMED_PHRASES: 'Consumed Phrases',
  INTERESTS: 'Interests',
  TV_SHOWS: 'TV Shows',
  PURCHASE_AFFINITIES: 'Purchase Affinities',
  CATEGORIES: 'Audience Affinities',
  LINKEDIN_INTERESTS: 'Interests',
};

export const VIEW_TYPES_NAMES = {
  bars: 'bars',
  chart: 'bars',
  table: 'table',
};

export const ALL_INTERESTS = 'All Interests';
export const ALL_CATEGORIES = 'All Categories';
export const DEFAULT_SORT = 'composition';

export const SORT_TYPE_TO_TOPIC_KEY = {
  portion: 'percents',
  composition: 'value',
};

export const VIEW_TYPES = [
  { value: 'bars', icon: 'list-hierarchical', label: '', width: '16px', height: '14px' },
  { value: 'table', icon: 'table', label: '', width: '16px', height: '14px' },
];

export const SORT_TYPES = [
  {
    value: 'portion',
    label: 'Consumption',
    tooltip: 'Sort by how popular the interest is among the audience',
  },
  {
    value: 'composition',
    label: 'Skew',
    tooltip: 'Sort by the extent to which the interest is over-indexed within the audience',
  },
];

export const TOO_WIDE_MSG =
  'The audience you have selected is too wide for Interests analysis. Please refine your audience criteria.';

export const TOO_NARROW_MSG =
  'The audience you have selected is too narrow for Interests analysis. Please refine your audience criteria.';
